"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMapFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25 8.99v2h3v14H4v-14h3v-2H2v18h28v-18h-5z" }),
        React.createElement("path", { d: "M15.31 19.72l.69.65.69-.65c.22-.21 5.31-5.13 5.31-10.27C22 5.28 19.87 3 16 3s-6 2.29-6 6.46c0 5.13 5.09 10.05 5.31 10.26zm2.94-10.23A2.25 2.25 0 1116 7.24a2.26 2.26 0 012.25 2.25z" })));
}
exports.default = SvgMapFilled;
//# sourceMappingURL=MapFilled.js.map